export const MEDIA_SECTION_ERROR = 'media-section-error';
export const MEDIA_INPUT_PENDING = 'media-input-pending';
export const MEDIA_INPUT_THUMBNAIL = 'media-input-thumbnail';
